/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Fragment } from "react";
import {
  Typography,
  Box,
  makeStyles,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  switchLabel: {
    marginTop: 20,
    textAlign: "center",
  },
  boxSwitch: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: 20,
  },
}));

const Step2 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState({
    qualite: 50,
  });
  const [choix, setChoix] = useState("");

  useEffect(() => {
    // Quand le composant se charge, autorise à passer à la suite
    props.setAuthorization(false);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRangeChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.valueAsNumber;
    props.setResult(newResult);
  };

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setChoix(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["choix"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        Je renseigne des informations sur l'offre proposée :
      </Typography>
      {/* Range */}
      <Typography variant="body1" className={classes.switchLabel}>
        La qualité globale de l'hébergement
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Médiocre
        </Typography>
        <input
          name="qualite"
          type="range"
          min="0"
          max="100"
          onChange={handleRangeChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Excellente
        </Typography>
      </Box>
      {/* Boutons radio */}
      <FormControl component="fieldset">
        <Typography variant="body1" style={{ marginLeft: 20 }}>
          Vous jugez que le choix d'offres était ...
        </Typography>
        <RadioGroup
          aria-label="hebergement"
          name="hebergement"
          value={choix}
          onChange={handleChange}
          style={{ marginLeft: 20 }}
        >
          <FormControlLabel
            value="abondant"
            control={<Radio />}
            label="Abondant"
          />
          <FormControlLabel
            value="insuffisant"
            control={<Radio />}
            label="Insuffisant"
          />
          <FormControlLabel
            value="aucune_offre"
            control={<Radio />}
            label="Il n'y a pas d'offre"
          />
          <FormControlLabel
            value="hebergements_fermes"
            control={<Radio />}
            label="Les hébergements sont fermés"
          />
        </RadioGroup>
      </FormControl>
    </Fragment>
  );
};

export default Step2;
